import { Badge, Button, Col, ColorPicker, Divider, Drawer, Dropdown, Flex, Form, Grid, Image, Input, Layout, notification, Row, Select, Space, Tooltip, Upload, message, theme } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { EditOutlined, UploadOutlined, DeleteOutlined, SignatureOutlined, InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { useSelector } from 'react-redux';
import { COLOR } from '../../../theme/constant';
import DrawSignature from './DrawSignature';
import UploadSignature from './UploadSignature';
import SignatureSettingsAPI from '../../../restAPI/SignatureSettingsAPI';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';
import useCurrentCompany from '../../../hooks/useCurrentCompany';
const { Header, Sider, Content } = Layout;

const { useBreakpoint } = Grid;
const { TextArea } = Input;

//const { Dragger } = Upload;
// const props = {
//   name: 'file',
//   multiple: true,
//   action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
//   onChange(info) {
//     const { status } = info.file;
//     if (status !== 'uploading') {
//       console.log(info.file, info.fileList);
//     }
//     if (status === 'done') {
//       message.success(`${info.file.name} file uploaded successfully.`);
//     } else if (status === 'error') {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   },
//   onDrop(e) {
//     console.log('Dropped files', e.dataTransfer.files);
//   },
// };

//  Function to generate color presets from the COLOR.js file
const genPresets = (colors) => {
  return Object.keys(colors).reduce((acc, colorKey) => {
    if (colorKey.endsWith('900')) {
      acc.push(colors[colorKey]); // Add only the colors ending with '900'
    }
    return acc;
  }, []);
};

export default function SignatureSettings() {
  const { companyId, token, userCompany } = useSelector(state => state.auth);
  const { token: { colorBgContainer, borderRadiusLG, colorBorder, colorPrimary, colorBgMask, colorBgElevated }, } = theme.useToken();
  const presets = genPresets(COLOR);
  const screens = useBreakpoint();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState('list');
  const [signatureName, setSignatureName] = useState('');
  const [signatureUrl, setSignatureUrl] = useState("");
  const [isSignatureAdded, setIsSignatureAdded] = useState(false);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);  
  const currentCompanyInfo = useCurrentCompany();
  const [listRefreshTick, setListRefreshTick] = useState(0);
  const lastFetchKeyRef = useRef('');
  const activeRequestKeyRef = useRef('');
  const abortControllerRef = useRef(null);


  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
        message: message,
        description: description,
        placement
    });
};

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const [fileList, setFileList] = useState([
    {
      uid: '-1',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
  ]);
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const geteSignatureData = async (companyInfo) => {  
    if(!companyInfo?.userDetailsId) return;

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;
    const requestKey = `${companyId}-${companyInfo.userDetailsId}`;
    activeRequestKeyRef.current = requestKey;
    setIsSignatureLoading(true);
     
    await SignatureSettingsAPI.geteSignatureByUserDetailsId(companyInfo.userDetailsId, companyId, token, controller.signal).then((res) => {
        if (abortControllerRef.current !== controller) return;
        if (activeRequestKeyRef.current !== requestKey) return;

        if (res?.data) {
          if(res.data?.signature){
            setIsSignatureAdded(true);
            setSignatureName(companyInfo.name + "'s eSignature");
            setSignatureUrl(res.data.signature);
          } else{
            setIsSignatureAdded(false);
            setSignatureName('');
            setSignatureUrl('');
          }
        }
      }).catch(err => {
        if (err?.name === 'AbortError' || err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') {
          return;
        }
        if (abortControllerRef.current !== controller) return;
        if (activeRequestKeyRef.current !== requestKey) return;

        setIsSignatureAdded(false);
        setSignatureName('');
        setSignatureUrl('');
        console.log("error getting esignature data :", err);
    }).finally(() => {
      if (abortControllerRef.current === controller && activeRequestKeyRef.current === requestKey) {
        setIsSignatureLoading(false);
      }
    })
  };

  
  useEffect(() => {
    const userDetailsId = currentCompanyInfo?.userDetailsId;
    if (view !== 'list' || !companyId || !token || !userDetailsId) return;

    const fetchKey = `${companyId}-${userDetailsId}-${listRefreshTick}`;
    if (lastFetchKeyRef.current === fetchKey) return;

    lastFetchKeyRef.current = fetchKey;
    geteSignatureData(currentCompanyInfo);
  }, [companyId, token, currentCompanyInfo, view, listRefreshTick]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const items = [
    {
      key: '1',
      label: 'Draw Signature',
      icon: <SignatureOutlined />,
      onClick: () => setView('draw'), // Set view to Draw Signature
    },
    {
      key: '2',
      label: 'Upload Signature',
      icon: <UploadOutlined />,
      onClick: () => setView('upload'), // Set view to Upload Signature
    },
  ];

  const deleteSignature = async () => {
    await SignatureSettingsAPI.deleteeSignature(currentCompanyInfo.userDetailsId, companyId, token)
        .then((res) => {
            openNotificationWithIcon('success', 'Successful', `eSignature deleted successfully`, 'bottomLeft');
            setIsSignatureAdded(false);
        setListRefreshTick((prev) => prev + 1);
            onClose();
        })
        .catch((err) => {
            if (err.response) {
                openNotificationWithIcon('error', 'eSignature delete failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'eSignature delete failed', `${err.message}`, 'bottomLeft');
            }
        });
  }

  const renderSignatureList = () => (
    <>
      {/* Header */}
      <div style={{ margin: '16px', padding: '8px 12px', background: colorBgContainer, borderRadius: borderRadiusLG }}>
        <Flex justify="space-between" align="center">
          <span>eSignature</span>
          <Dropdown disabled={isSignatureAdded}
            menu={{ items }}
          >
            <Button disabled={isSignatureAdded} type="primary"> Add </Button>
          </Dropdown>
        </Flex>
      </div>

      {/* Signature Cards */}
      {[1].map((signature, index) => (
        <div  hidden={!isSignatureAdded} key={index} style={{ marginBottom: 8, margin: '16px', padding: '10px 24px', background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Flex  justify="space-between" align="center" gap={16}>
            <div style={{ 
              padding: '12px',
              background: '#f5f5f5',
              borderRadius: borderRadiusLG,
              border: `1px solid ${colorBorder}`,
            }}>
              <Image
                width={200}
                src={signatureUrl}
                style={{ 
                  borderRadius: borderRadiusLG,
                  display: 'block',
                }}
                preview={{
                  mask: 'Preview',
                  maskClassName: 'signature-preview-mask',
                  styles: {
                    mask: {
                      background: 'rgba(0, 0, 0, 0.65)',
                    },
                    body: {
                      background: 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    },
                  },
                  imageRender: (originalNode) => (
                    <div style={{
                      background: '#f5f5f5',
                      padding: '20px',
                      borderRadius: '8px',
                      display: 'inline-block',
                    }}>
                      {originalNode}
                    </div>
                  ),
                }}
              />
            </div>
            <div>
              <p>{signatureName}</p>
            </div>
            <Flex align="center" gap={20}>
              {/* <Tooltip title="Edit">
                <Button type="text" icon={<EditOutlined />} />
              </Tooltip> */}
              <Tooltip title="Delete">
                <Button type="text" onClick={deleteSignature} icon={<DeleteOutlined />} />
              </Tooltip>
            </Flex>
          </Flex>
        </div>
      ))}
    </>
  );

  const renderView = () => {
    switch (view) {
      case 'draw':
        return <DrawSignature goBack={() => {
          setView('list');
          setListRefreshTick((prev) => prev + 1);
        }} />;
      case 'upload':
        return <UploadSignature goBack={() => {
          setView('list');
          setListRefreshTick((prev) => prev + 1);
        }} />;
      default:
        if (isSignatureLoading) {
          return <CommonSkeletonLoader itemCount={2} />;
        }
        return renderSignatureList();
    }
  };

  return (
    <>
      <div>
      {renderView()}
    </div>

    {contextHolder}
    </>
  )
}
